
export default {
	items: {},
	itemIds: [],
	totals: { total: 0 },
}